import { FooterContext } from "@contexts/FooterContext";
import React, { useContext } from "react";
import Facebook from "../SVGs/social-icons/Facebook";
import Twitter from "../SVGs/social-icons/Twitter";
import Instagram from "../SVGs/social-icons/Instagram";
import LinkedIn from "../SVGs/social-icons/Linkedin";

const SocialMediaIcons: React.FC = () => {
  const { socialLinks } = useContext(FooterContext);

  const className =
    "border-forest-900 border-solid border-[1.5px] rounded-[8.88px] w-10 h-10 flex justify-center items-center hover:bg-sun-300 active:bg-sun-600";

  return (
    <div className="flex items-center gap-4 sm:gap-3">
      <a
        href={socialLinks?.facebook}
        target="_blank"
        className={className}
        rel="noreferrer"
      >
        <Facebook />
      </a>
      <a
        href={socialLinks?.xTwitter}
        target="_blank"
        className={className}
        rel="noreferrer"
      >
        <Twitter />
      </a>
      <a
        href={socialLinks?.instagram}
        target="_blank"
        className={className}
        rel="noreferrer"
      >
        <Instagram />
      </a>
      <a
        href={socialLinks?.linkedin}
        target="_blank"
        className={className}
        rel="noreferrer"
      >
        <LinkedIn />
      </a>
    </div>
  );
};

export default SocialMediaIcons;
